import dissocPath from "ramda/es/dissocPath";
import forEachObjIndexed from "ramda/es/forEachObjIndexed";
/**
 * omit given paths from object
 *
 * @documented
 * @category Object
 * @param {Array[]} paths - array of paths
 * @param {Object} object
 * @example
 *
 * 		omitPathsFromObject('person.name', { person: { name: 'name' } }) // => {}
 *
 */ const omitPathsFromObject = (paths, object)=>{
    let formDataWithoutFiles = {
        ...object
    };
    forEachObjIndexed((value)=>{
        formDataWithoutFiles = dissocPath(value, formDataWithoutFiles);
    }, paths);
    return formDataWithoutFiles;
};
export default omitPathsFromObject;
